import { useEffect, useRef } from "react";

export const useMountEffectOnce = (fn: () => void) => {
    const hasRun = useRef(false);
    const fnRef = useRef(fn);
    fnRef.current = fn;

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        fnRef.current();
    }, []);
};
